export default {
    'cart.global.withDph': 's DPH',

    'product.showMoreBtn': 'Zobraziť viac',
    'product.cartBtn': 'Pridať',

    'contact.phoneNumber': '+420 585 311 666',
    'contact.email': 'info@vsevyhodne.cz',
    'contact.openingHours': 'Po-Pi 7:00 - 14:00',

    'newsletter.title': 'Získajte výhody vždy ako prvý!',
    'newsletter.btn': 'Prihlásiť sa k odberu',

    'input.emailPlaceholder': 'Váš e-mail',

    'header.mobileMenuHeading': 'Hlavné kategórie',
    'header.otherCategories': 'Ostatné',

    'category.loading': 'Zobraziť ďalšie',
    'category.availability': 'Skladom',

    'detail.brand': 'Výrobca:',
    'detail.expirationDate': 'Dátum expirácie',

    'login.title': 'Prihlásenie k účtu',

    'cart.showCart': 'Nákupný košík',

    'advancedOrder.productsHeader': 'Ostatní si tiež zakúpili',

    'cart.step1.next': 'Vybrať dopravu a platbu',
    'cart.step1.addCoupon': 'Pridať',
    'cart.step1.addCouponTitle': 'Zľavový kupón',
    'cart.step1.gift': 'Darček',
    'cart.step1.giftFree': 'Darček zadarmo!',

    'cart.step2.nextStepBtn': 'Doplniť informácie o vás',

    'cart.step3.loginLink': 'Prihlásiť sa k účtu',

    'cart.thankYouPage.heading': 'Objednávka bola úspešne odoslaná',
    'cart.thankYouPage.thankYouOrderNumber': 'Ďakujeme za Vašu objednávku číslo',
    'cart.thankYouPage.orderNumber': 'Číslo objednávky',

    'cart.emptyCart.backToShop': 'Späť do obchodu',
    'cart.emptyCart.emptyCart': 'Váš košík je prázdný',
    'cart.emptyCart.emptyCartSubtitle': 'Váš košík čeká na své první objevy – podívejte se na naši nabídku!',

    'cart.step1.orderSummary': 'Rekapitulácia objednávky',

    'reviews.name': 'Overený zákazník',

    'contact.title': 'Kontaktujte nás',

    'terms.text':
        '<a href="/nakupny-poriadok/">Obchodné podmienky</a> a <a href="/ochrana-osobnych-udajov/">Podmienky ochrany osobných údajov </a>',
}
